import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
// Design System - Order matters!
import './styles/tokens.css'              // 1. Design tokens (single source of truth)
import './styles/components.foundation.css' // 2. Foundation components
import './styles/global.css'              // 3. Global base styles
import './styles/components.css'          // 4. Legacy components
import './styles/home.css'
import './styles/login.css'
import './styles/dashboard.css'
import './styles/newsletter.css'
import './styles/my-prospects.css'
import './styles/prospects.css'
import './styles/prelogin.css'
import './styles/tailwind.css'
// SERGE styles MUST be imported AFTER tailwind.css for proper override
import './styles/serge-base.css'          // SERGE: Critical base styles (fonts, colors, etc.)
import './styles/serge-design.css'
import './styles/serge-workspace.css'
import { useAuthStore } from './stores/authStore.js'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Initialize auth state from localStorage before first render
try {
  useAuthStore.getState().initFromStorage()
} catch (_) {
  // noop
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
